import { SamplesEvent } from "../scripts/samples.entities";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";
export class SamplesDatatableEntry {
    Study: string;
    Appendix: string;
    Site: string;
    SiteNumber: string;
    Visit: string;
    Sample: string;
    VisitAbb: number;

    PotentialSamples: number;
    ExpectedSamples: number;
    Completed: number[] = [];
    Overdue: number[] = [];
    NotDone: number[] = [];
    DiscPrior: number[] = [];
    NotYetDue: number;
    Missing: number[] = [];
    OverdueMissing: number[] = [];

    CompletedVisits: SamplesEvent[] = [];
    OverdueVisits: SamplesEvent[] = [];
    NotDoneVisits: SamplesEvent[] = [];
    DiscPriorVisits: SamplesEvent[] = [];
    MissingVisits: SamplesEvent[] = [];

    sortValue: number;

    constructor(study: string, appendix: string, site: string, siteNumber: string, visit: string, sample: string, visitAbb?: number) {
        this.Study = study;
        this.Appendix = appendix;
        this.Site = site;
        this.SiteNumber = siteNumber;
        this.Visit = visit;
        this.Sample = sample;
        this.VisitAbb = visitAbb ?? null;

        if (visitAbb !== undefined && visitAbb !== null) {
            this.sortValue = VisitLookup.GetVisitMasterOrdering(visitAbb);
        } else {
            this.sortValue = 0;
        }

        this.PotentialSamples = 0;
        this.ExpectedSamples = 0;
        this.NotYetDue = 0;
    }

    addSamplesEvent(sample: SamplesEvent): void {
        this.PotentialSamples += 1;
        switch (sample.SamplesStatusId) {
            case 1:
                this.Completed[0] = (this.Completed[0] ?? 0) + 1;
                this.ExpectedSamples++;
                this.CompletedVisits.push(sample);
                break;
            case 6:
                this.Overdue[0] = (this.Overdue[0] ?? 0) + 1;
                this.ExpectedSamples++;
                this.OverdueVisits.push(sample);
                break;
            case 4:
                this.NotDone[0] = (this.NotDone[0] ?? 0) + 1;
                this.ExpectedSamples++;
                this.NotDoneVisits.push(sample);
                break;
            case 2:
                this.DiscPrior[0] = (this.DiscPrior[0] ?? 0) + 1;
                this.ExpectedSamples++;
                this.DiscPriorVisits.push(sample);
                break;
            case 3:
                this.Missing[0] = (this.Missing[0] ?? 0) + 1;
                this.ExpectedSamples++;
                this.MissingVisits.push(sample);
                break;
            case 5:
                this.NotYetDue = (this.NotYetDue ?? 0) + 1;
                break;
        }
    }
    initialize(): void {
        if (this.ExpectedSamples > 0) {
            if (this.Completed[0] != undefined) { this.Completed[1] = (this.Completed[0] / this.ExpectedSamples); }
            if ((this.Overdue[0] != undefined || this.Missing[0] != undefined)) {
                const overdueCount = this.Overdue[0] ?? 0;
                const missingCount = this.Missing[0] ?? 0;
                this.OverdueMissing = [
                    overdueCount + missingCount,
                    (overdueCount + missingCount) / this.ExpectedSamples
                ];
            }
            if (this.NotDone[0] != undefined) { this.NotDone[1] = (this.NotDone[0] / this.ExpectedSamples); }
            if (this.DiscPrior[0] != undefined) { this.DiscPrior[1] = (this.DiscPrior[0] / this.ExpectedSamples); }
        }
    }

    static addValue(currentValue: number, valueToAdd: number): number {
        if (currentValue == undefined) { currentValue = 0; }
        currentValue += valueToAdd;
        return currentValue;
    }

    static getHash(grouping: string, visit: SamplesEvent): string {
        if (grouping == "none") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber + "-" + visit.VisitAbb + "-" + visit.BiospecId; }
        else if (grouping == "by-visit") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.VisitAbb; }
        else if (grouping == "by-site") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.SiteNumber; }
        else if (grouping == "by-samples") { return visit.StudyId + "-" + visit.AppendixId + "-" + visit.BiospecId; }
        else return "unknown";
    }
}